// @ts-nocheck
import React, { useState } from 'react';
import {
  Grid,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import {
  SecondaryButton,
  PrimaryButton,
} from 'components/__v2__/Button/ReusableButton';
import { LocationOnIcon } from 'assets/icons';
import { useGooglePlaces } from 'hooks/common';
import { Logger } from 'utils/logger';
import PreviewMap from '../../components/PreviewMap';

const AddressFieldPreview = ({
  answer,
  handleAnswerChange,
  shouldBeReadOnly,
}) => {
  const [openMapDialog, setOpenMapDialog] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const { getGeocodeByLatLng } = useGooglePlaces();

  const handleMapClick = (lat, lng) => {
    const location = { lat, lng };
    setSelectedLocation(location);
  };

  const handleDialogClose = async () => {
    if (selectedLocation) {
      const result = await getGeocodeByLatLng(
        selectedLocation.lat,
        selectedLocation.lng,
      );
      const address = result[0]?.formatted_address;
      if (address) {
        handleAnswerChange({ target: { value: address } });
      } else {
        Logger.error('Failed to fetch address');
      }
    }
    setOpenMapDialog(false);
  };

  const handleTextChange = ({ target: { value } }) => {
    handleAnswerChange({ target: { value } });
  };

  return (
    <>
      <Grid display="flex" alignItems="center" gap={1}>
        <TextField
          name="Address"
          value={answer || ''}
          onChange={handleTextChange}
          variant="outlined"
          fullWidth
          placeholder="Enter your address"
          disabled={shouldBeReadOnly}
        />
        <IconButton onClick={() => setOpenMapDialog(true)}>
          <LocationOnIcon />
        </IconButton>
      </Grid>
      <Dialog
        open={openMapDialog}
        onClose={() => setOpenMapDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          {shouldBeReadOnly ? 'View Location' : 'Select Location'}
        </DialogTitle>
        <DialogContent>
          <PreviewMap location={selectedLocation} onMapClick={handleMapClick} />
        </DialogContent>
        {!shouldBeReadOnly && (
          <DialogActions>
            <SecondaryButton
              onClick={() => setOpenMapDialog(false)}
              variant="outlined"
              size="small"
            >
              Cancel
            </SecondaryButton>
            <PrimaryButton onClick={handleDialogClose} color="primary">
              Confirm
            </PrimaryButton>
          </DialogActions>
        )}
      </Dialog>
    </>
  );
};

export default AddressFieldPreview;
